import store from '@/store/index'
// import {NavigationGuard} from "vue-router";
import {Route} from "vue-router/types/router";

export default (to: Route, from: Route, next: (to?: any) => void)  => {
	if (store.state.isLoggedIn && to.name === 'Login') return next({name: 'InstrumentosList'})
	else if (!store.state.isLoggedIn && to.name !== 'Login') return next({name: 'Login'})
	else next()
}
